import { ANIMATION_DURATION } from "components/Message/configs";
import { Button, Heading } from "iparque-components";
import styled from "styled-components";
import { InnerContainer } from "../styles";

interface StyledInnerContainerProps {
  isVisible: boolean;
}

interface FormVisibleProps {
  isFormVisible: boolean;
}

export const StyledInnerContainer = styled(
  InnerContainer
)<StyledInnerContainerProps>`
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transition: opacity ${ANIMATION_DURATION};
  gap: 24px;
  padding: 48px 32px;
`;

export const TextContainer = styled.div<FormVisibleProps>`
  transform: translateY(${({ isFormVisible }) => (isFormVisible ? 30 : 0)}px);
  transition: transform ${ANIMATION_DURATION}, opacity ${ANIMATION_DURATION};
`;

export const StyledHeading = styled(Heading)`
  line-height: 1em;
`;

export const StyledButton = styled(Button)<FormVisibleProps>`
  transition: transform ${ANIMATION_DURATION}, opacity ${ANIMATION_DURATION};

  ${({ isFormVisible }) =>
    isFormVisible
      ? `
          opacity: 0;
          transform: translateY(60px);
          pointer-events: none;
        `
      : `
          opacity: 1;
          pointer-events: initial;
        `}
`;
